<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import SubmissionHistory from '@/views/Sbr/SubmissionHistory.vue'

definePage({
  meta: { ...PageMeta.Sbr.Submissions.Meta, pageTitle: PageMeta.Sbr.Submissions.Title },
})
</script>

<template>
  <SubmissionHistory />
</template>
